import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { DynamicBG } from "~/components/blocks";
import {
  Margin,
  Title,
  Text,
  Button,
  ErrorMessage,
  Loading,
} from "~/components/elements";
import * as S from "./styles";
import { scrollTop, parentScrollTop } from "~/utils/tools";
import { Creators as AuthenticationActions } from "~/store/modules/authentication/actions";
import { Creators as AccountActions } from "~/store/modules/account/actions";
import isMobile from "~/hooks/isMobile";
import history from "~/routes/history";

export default function VerifyNewEmail() {
  const mobile = isMobile();
  const dispatch = useDispatch();

  // const urlStorage = localStorage.getItem("url");
  // const url = urlStorage !== "null" ? urlStorage : window.location.origin;

  const url = process.env.REACT_APP_HOST_URL;
  const origin = process.env.REACT_APP_ORIGIN;

  const Code = window.location.pathname.split("/")[2];

  const sending = useSelector((state) => state?.account?.newEmail?.sending);
  const errorMessage = useSelector((state) => state?.account?.newEmail?.message);
  const success = useSelector((state) => state?.account?.newEmail?.success);
  const newEmail = useSelector((state) => state?.account?.newEmail?.email);

  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const animations = {
    exit: { y: "50%", opacity: 0, transition },
    enter: {
      y: "0%",
      opacity: 1,
      transition,
    },
  };

  useEffect(() => {
    scrollTop();
    parentScrollTop();
    if (Code && !success) {
      dispatch(
        AccountActions.sendConfirmEmailCode({
          Code: Code,
          confirm_email: true,
          url: url,
          origin: origin,
        })
      );
      dispatch(AuthenticationActions.purgeAuthentication());
    }

    if (success) {
      dispatch(AccountActions.setUpdateEmail());
    }
  }, [dispatch, Code, success, url, origin]);

  return (
    <>
      <motion.div
        variants={animations}
        className="single"
        initial="exit"
        animate="enter"
        exit="exit"
      >
        <DynamicBG content={true}>
          {sending ? (
            <Margin mt={mobile ? 6 : 12} mb={mobile ? 8 : 12}>
              <Loading />
            </Margin>
          ) : (
            <S.ContentHolder success={success}>
              <Margin mt={mobile ? 6 : 12} mb={mobile ? 1 : 2}>
                {success && (
                  <Title as="2" level="4" levelDesktop="3">
                    ¡El correo electrónico se cambió con éxito!
                  </Title>
                )}
                {!success && errorMessage && (
                  <Title as="2" level="4" levelDesktop="3">
                    Lo siento. No pudimos realizar esa acción.
                  </Title>
                )}
              </Margin>
              <Margin mb={4}>
                <S.TextHolder>
                  {success ? (
                    <Text level="1">
                      Recibirás nuestras comunicaciones en tu nuevo e-mail{" "}
                      <strong>{newEmail}</strong>. Debes iniciar sesión para
                      ingresar a tu cuenta con tu nuevo e-mail.
                    </Text>
                  ) : (
                    <ErrorMessage inset>{errorMessage}</ErrorMessage>
                  )}
                </S.TextHolder>
              </Margin>
              <Margin mb={mobile ? 8 : 12}>
                <Button
                  onClick={() => history.push("/minha-conta")}
                  color="primary"
                  id="loginButtonVerify"
                >
                  INICIAR SESIÓN
                </Button>
              </Margin>
            </S.ContentHolder>
          )}
        </DynamicBG>
      </motion.div>
    </>
  );
}
